"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicCardHeader = exports.BasicCardElement = exports.BasicCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const BasicCard = ({ divider, children, className }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex flex-col overflow-hidden rounded-lg border border-grey-2 bg-white lg:flex-row', { 'divide-y divide-grey-2 lg:divide-y-0 lg:divide-x': divider }, className) }, children));
};
exports.BasicCard = BasicCard;
const BasicCardElement = ({ children, className }) => {
    return react_1.default.createElement("div", { className: `px-4 py-6 lg:px-14 lg:py-12 ${className}` }, children);
};
exports.BasicCardElement = BasicCardElement;
const BasicCardHeader = ({ children, className }) => {
    return react_1.default.createElement("div", { className: `border-b border-grey-2 bg-slate-1 px-4 py-6 lg:px-14 lg:py-12 ${className}` }, children);
};
exports.BasicCardHeader = BasicCardHeader;
